import { statusColors } from "../../../../../utils/colors";

export const getQoEconfig = (qoeValues, tViews) => {
    const { vqoe, totalAppCount } = qoeValues;

    const data = [
        {
            id: "good",
            label: tViews('applicationOverviewLabelGood'),
            value: vqoe["good"],
            color: statusColors.good
        },
        {
            id: "fair",
            label: tViews('applicationOverviewLabelFair'),
            value: vqoe["fair"],
            color: statusColors.fair
        },
        {
            id: "poor",
            label: tViews('applicationOverviewLabelPoor'),
            value: vqoe["poor"],
            color: statusColors.poor
        },
        {
            id: "unknown",
            label: tViews('applicationOverviewLabelNotAvailable'),
            value: vqoe["unknown"],
            color: statusColors.gray
        }
    ];

    return {
        id: "label",
        innerRadius: 0.7,
        enableArcLinkLabels: false,
        width: 180,
        height: 180,
        margin: { top: 10, bottom: 32, left: 0, right: 0 },
        data: data,
        colors: ({ data }) => data.color,
        legends: [],
        centerContent: () => {
            return `
        <div style="display: flex; height: 100%; flex-direction: column; justify-content: center;align-items: center;">
          <div style="font-size: 24px; font-weight: 400">${totalAppCount}</div>
          <div>${tViews('appExperienceApplications')}</div>
        </div>`;
        }

    }
}

